//@flow -strict-local
import PreviewController from "../controllers/preview/PreviewController";

const debug = require('../debug/debug')('wc:auth:MaintainSessionWithPreviewServer');
export default class MaintainSessionWithPreviewServer {

  static NAME: string;

  constructor() {
    debug('[MaintainSessionWithPreviewServer()] Sending request to maintain session with preview-server');
    const isAuthSuccess = MaintainSessionWithPreviewServer.issuePreviewServerHealthCheckCall();
    isAuthSuccess.then((data) => {
      debug('[MaintainSessionWithPreviewServer()] preview server status check:' + data);
    });    
  }

  static async issuePreviewServerHealthCheckCall() {
    let isAuthSuccess = await PreviewController.checkPreviewAuthentication();
    if (isAuthSuccess === false) {
      isAuthSuccess = await PreviewController.issuePreviewServerAuth(true);
    }
    return isAuthSuccess;
  }

  /* onAjaxSuccess = (data: Object, textStatus: string, jqXHR: Object): void => {
     const status: number = jqXHR.status;
     if (HttpOperation.checkForAuthFailure(status, data)) {
       this.handleAuthFailure();
     }
   };

   onFail = (jqXHR: Object, textStatus: string, errorThrown: Object): void => {
     if (HttpOperation.checkForAuthFailure(status, undefined)) {
       this.handleAuthFailure();
     }
   };*/

  /* handleAuthFailure(): void {
     debug('[handleAuthFailure()]');
     if (System.isBrowserApp())
       Authenticator.getInstance().invokeOnAuthFailureCallback();
   }*/
}

MaintainSessionWithPreviewServer.NAME = 'MaintainSessionWithPreviewServer';